<div class="modal-header">
  <h4 class="modal-title pull-left">Tax Returns / Financials</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <b>Copy financial year from the Primary Entity?</b>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" (click)="onConfirm()">Yes</button>
</div>
